import { ReactNode, useCallback } from 'react';

import { updateApplicantProfile } from 'modules/main/store/ducks/userEnvironment.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import {
  NOTIFICATIONS,
  NotificationStatus,
  useUpdateLocalNotification,
} from 'utils/localNotifications';

function ResumeDatabaseResponseContainer({
  children,
}: {
  children: (arg0: { dismiss: () => void }) => ReactNode;
}) {
  const { user } = useUserEnvironment();
  const dispatch = useMainDispatch();
  const updateLocalNotification = useUpdateLocalNotification();

  const dismiss = useCallback(() => {
    if (user) {
      dispatch(
        updateApplicantProfile({
          isRecruitable: false,
        }),
      );
    }

    // TODO why not dismiss when the user is not logged in?
    updateLocalNotification(NOTIFICATIONS.UPLOAD_RESUME, {
      status: NotificationStatus.DISMISSED,
    });
  }, [dispatch, updateLocalNotification, user]);

  return <>{children({ dismiss })}</>;
}

// eslint-disable-next-line import/no-default-export
export default ResumeDatabaseResponseContainer;
